import React from 'react';
import { SelectedTenantIdAtom, selectedZEVID } from '../../state/states';
import { useAtom } from '@gothub-team/got-atom';
import { SelectionModals } from '../components/SelectionModals';
import ZevSelectionMobile from './ZevSelectionMobile';
import TenantSelectionMobile from '../sharedScreenComponents/TenantSelectionMobile';

export const SelectModals = () => {
    const tenantId = useAtom(SelectedTenantIdAtom);
    const zevId = useAtom(selectedZEVID);
    const isZEVSelected = tenantId === zevId;

    const components = [
        {
            title: 'ZEV wählen',
            transformation: !zevId ? 'translateX(0vw)' : 'translateX(-100vw)',
            component: <ZevSelectionMobile />,
        },
        {
            title: 'Zähler wählen',
            transformation: zevId && !tenantId ? 'translateX(0vw)' : 'translateX(-100vw)',
            component: <TenantSelectionMobile />,
            onBack: () => {
                SelectedTenantIdAtom.set(undefined);
                selectedZEVID.set(undefined);
            },
        },
    ];
    return (
        <SelectionModals
            backdropToggle={zevId && (tenantId || isZEVSelected) ? true : false}
            components={components}
        />
    );
};
